import { Switch } from '@material-ui/core';
import React from 'react';

import { ScoreType } from '../../../../store/admin/eventFormats/store';

import {
  useAssignResultsDispatch,
  useAssignResultsState
} from '../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';

export const ScoreTypeSwitch = () => {
  const { selectedScoreType, selectedRoundFormat } = useAssignResultsState();
  const { dispatch: dispatchAssignResults } = useAssignResultsDispatch();

  const onChangeToggle = () => () =>
    dispatchAssignResults({
      type: 'selectScoreType',
      value: selectedScoreType === ScoreType.GROSS ? ScoreType.NET : ScoreType.GROSS
    });

  return selectedRoundFormat && selectedRoundFormat.scoreTypes.length > 1 ? (
    <div className="score-type-switch">
      <div className="score-type-switch__title">SHOW LEADERBOARD FOR:</div>
      <div className="score-type-switch__container">
        <div className="score-type-switch__container__item">NET</div>
        <div className="score-type-switch__container__item">
          <Switch
            checked={selectedScoreType === ScoreType.GROSS}
            onChange={onChangeToggle()}
            color="primary"
          />
        </div>
        <div className="score-type-switch__container__item">GROSS</div>
      </div>
    </div>
  ) : (
    <></>
  );
};
